import React, { useRef } from 'react'
import { ReactComponent as UploadCloudIcon } from 'svg/upload-cloud-icon.svg'

interface UploadAreaProps {
  isUploading?: boolean
  isDragOver?: boolean
  onDragOver?: (e: React.DragEvent) => void
  onDragLeave?: (e: React.DragEvent) => void
  onDrop?: (e: React.DragEvent) => void
  onFileSelect?: (e: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
}

export const UploadArea: React.FC<UploadAreaProps> = ({
  isUploading = false,
  isDragOver = false,
  onDragOver,
  onDragLeave,
  onDrop,
  onFileSelect,
  disabled = false,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleClick = () => {
    if (!disabled && !isUploading) {
      fileInputRef.current?.click()
    }
  }

  return (
    <div
      className={`w-[138px] h-[138px] bg-[#F6F8FB] rounded-[10px] border border-dashed border-[#D9DEE8] flex flex-col items-center justify-center cursor-pointer transition-colors relative ${
        isDragOver ? 'bg-blue-50 border-blue-300' : ''
      } ${isUploading || disabled ? 'opacity-75 cursor-not-allowed' : ''}`}
      onDragOver={!disabled && !isUploading ? onDragOver : undefined}
      onDragLeave={!disabled && !isUploading ? onDragLeave : undefined}
      onDrop={!disabled && !isUploading ? onDrop : undefined}
      onClick={handleClick}
    >
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={onFileSelect}
        className="hidden"
        disabled={disabled || isUploading}
      />

      {isUploading ? (
        <>
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-[#00B7B9] mb-2"></div>
          <span className="text-[14px] text-[#00B7B9] text-center leading-tight">
            업로드 중...
          </span>
        </>
      ) : (
        <>
          <UploadCloudIcon className="text-[#8F929B] mb-2" />
          <span className="text-[14px] text-[#8F929B] text-center leading-tight">
            100MB 미만
            <br />
            PNG / JPG
          </span>
        </>
      )}

      <div className="absolute inset-[6px] border border-dashed border-[#D9DEE8] rounded-[6px] pointer-events-none"></div>
    </div>
  )
}
